module.exports = __webpack_public_path__ + "img/payments.488de6f3.svg";